'use client';

import { useEffect, useState } from 'react';
import { getArticles } from '@/services/apis/modules/article';
import Link from 'next/link';
import Image from 'next/image';
import { PATH_URL } from '@/statics/static';
import Empty from '@/components/atoms/empty';
import Pagination from '@/components/atoms/pagination';
import Skeleton from '@/components/atoms/skeletons';

interface RelatedArticlesProps {
  categoryIds: any[];
  currentId: string;
}

export default function RelatedArticles({
  categoryIds,
  currentId,
}: RelatedArticlesProps) {
  const [relatedArticles, setRelatedArticles] = useState<any[]>([]);
  const [total, setTotal] = useState<number>();
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    current: 1,
  });

  useEffect(() => {
    const fetchRelatedArticles = async () => {
      try {
        const result = await getArticles({
          pageIndex: pagination.current,
          pageSize: pagination.pageSize,
          keyword: '',
          category_ids: categoryIds,
        });
        setTotal(result?.total);
        const filtered =
          result?.records?.filter((item) => item.id !== currentId) || [];
        setRelatedArticles(filtered);
      } catch (error) {
        console.error('Failed to fetch related articles:', error);
      } finally {
        setLoading(false);
      }
    };

    if (categoryIds?.length) {
      fetchRelatedArticles();
    }
  }, [categoryIds, currentId, pagination.current]);

  const onPageChange = (page: number) => {
    setPagination({
      ...pagination,
      current: page,
    });
  };

  return (
    <div className="p-article-detail_other_related">
      <div className="p-article-detail_other_related_title">
        Bài viết liên quan
      </div>
      <div className="p-article-detail_other_related_list">
        {loading ? (
          <>
            <Skeleton active type="default" loading paragraph={{ rows: 5 }} />
            <Skeleton active type="default" loading paragraph={{ rows: 5 }} />
            <Skeleton active type="default" loading paragraph={{ rows: 5 }} />
            <Skeleton active type="default" loading paragraph={{ rows: 5 }} />
          </>
        ) : !relatedArticles.length ? (
          <Empty />
        ) : (
          relatedArticles.map((item) => (
            <Link
              className="p-article-detail_other_related_list_item"
              key={item?.id}
              href={`${PATH_URL.ARTICLE_URL}/${item?.slug}?id=${item?.id}`}
            >
              <div className="p-article-detail_other_related_list_item_left">
                <Image
                  src={item?.thumbnail}
                  alt="bai-viet-lien-quan"
                  width={280}
                  height={210}
                  loading="lazy"
                />
              </div>
              <div className="p-article-detail_other_related_list_item_right">
                <div className="p-article-detail_other_related_list_item_right_title">
                  {item?.title}
                </div>
                {item?.summary && (
                  <div className="p-article-detail_other_related_list_item_right_desc">
                    {item.summary}
                  </div>
                )}
              </div>
            </Link>
          ))
        )}
      </div>
      <Pagination
        onChange={onPageChange}
        pageSize={pagination.pageSize}
        current={pagination.current}
        total={total}
      />
    </div>
  );
}
